import React from "react";
import "./InteractionMenu.styles.css";
import PositionButtons from "./PositionButtons";
import SaveButtons from "./SaveButtons";
export default function InteractionMenu({ set_linkURL }) {
  return (
    <div className="interaction-menu">
      {/* <div className="URL-search">
        <input
          type="text"
          onChange={(e) => {
            set_linkURL(e.target.value);
          }}
        />
      </div> */}
      <PositionButtons />
      <div className="attach-file">
        <input
          style={{ display: "none" }}
          type="file"
          accept=".jpg, .jpeg, .png"
          id="myfile"
          name="myfile"
          onChange={(e) => {
            if (document.querySelector("#myfile").files.length !== 0) {
              set_linkURL(URL.createObjectURL(e.target.files[0]));
            }
          }}
        />
      </div>

      <SaveButtons />
    </div>
  );
}
